import React from 'react';
import styled from '@emotion/styled';
import { Space, ButtonProps } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import List from 'app/components/List';
import { Caption } from 'app/components/Typography/Caption';
import Button from 'app/components/Button';
import { IProduct } from 'app/types/interfaces/Product';
import { Title } from 'app/components/Typography/Title';
import Avatar from 'app/components/Avatar';
import WithModal from 'app/components/Modal/WithModal';
import { TemplateForm } from 'app/components/Forms/Template';

const StyledItem = styled(List.Item)`
  min-height: 150px;
  > div {
    > .ant-space-item {
      width: 100%;
      h5 {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0.005em;
        text-align: left;
        margin-bottom: 0;
      }
      &:nth-of-type(2) {
        width: 100%;
      }
      .ant-avatar {
        height: 54px;
        width: 80px;
        border: 0.5px solid rgba(240, 240, 240, 1);
        background: rgba(240, 240, 240, 1);
      }
    }
  }
`;
const StyledCaption = styled(Caption)`
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.01em;
  text-align: left;
  color: rgba(137, 145, 160, 1);
`;
const StyledPlaceHolder = styled.span`
  > svg {
    width: 90px;
    height: 60px;
  }
`;

const LinkageTemplateModal = WithModal(TemplateForm);

const ProductItem = (props: {
  product: IProduct;
  order: number;
  buttonProps?: ButtonProps;
  hiddenOrder?: boolean;
  className?: any;
  linkageTemplate?: {
    name: string;
    id: string | number;
    scheme: string;
  };
}) => {
  const {
    product,
    order,
    hiddenOrder = false,
    className,
    buttonProps,
    linkageTemplate = undefined
  } = props;
  return (
    <StyledItem className={className}>
      {!hiddenOrder && (
        <div style={{ width: 30, marginRight: 8 }}>
          <Caption>{`${order + 1}`.padStart(2, '0')}</Caption>
        </div>
      )}
      <Space size={16} style={{ width: '100%' }}>
        <List.Item.Meta
          avatar={
            <Avatar
              shape="square"
              size="large"
              src={product?.image ?? ''}
              placeholder={
                <StyledPlaceHolder>
                  {Avatar.PLACE_HOLDERS['COMPANY']}
                </StyledPlaceHolder>
              }
            ></Avatar>
          }
          description={
            <Space className="wrapperDescription" direction="vertical" size={0}>
              <Title level={5}>{product.name}</Title>
              <StyledCaption> {product.itemNo || ''}</StyledCaption>
              <Space>
                <HomeOutlined />
                <StyledCaption>{product?.supplier?.name}</StyledCaption>
              </Space>
              {linkageTemplate && (
                <LinkageTemplateModal
                  mode="view"
                  title={linkageTemplate.name}
                  width="50vw"
                  triggerElement={
                    <Button type="link">{linkageTemplate.name}</Button>
                  }
                  scheme={linkageTemplate.scheme}
                  footer={null}
                />
              )}
            </Space>
          }
        ></List.Item.Meta>
      </Space>
      <Button danger ghost borderRadius={4} {...buttonProps}>
        {buttonProps?.children || 'Remove'}
      </Button>
    </StyledItem>
  );
};

export default ProductItem;
